import React, {useState} from 'react';
import styled from 'styled-components';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation, Pagination} from 'swiper';
import {useRouter} from 'next/router';
import {useDispatch} from 'react-redux';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";


import {convertThumbnailToPictureProps} from '@tager/web-modules';
import {FETCH_STATUSES} from '@tager/web-core';

import {getAliasString} from '@/utils/common';
import {useTypedSelector} from '@/store/store';
import {activeIdAdded, selectProductResource,} from '@/store/reducers/pages/product/product';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import Picture from '@/components/Picture';
import Spinner from '@/components/Spinner';

SwiperCore.use([Navigation, Pagination]);

function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const router = useRouter();
  const dispatch = useDispatch();
  const alias = getAliasString(router.query.alias);
  const product = useTypedSelector((state) => {
    return selectProductResource(state, alias);
  });
  const gallery = product.data?.gallery;

  const [open, setOpen] = React.useState(false);
  const [index, setIndex] = React.useState(0);

  return (
    <>
      <Lightbox
        index={index}
        on={{ view: ({ index: currentIndex }) => setIndex(currentIndex) }}
        open={open}
        close={() => setOpen(false)}
        slides={gallery?.map(item => ({src: item.image?.preview.url_2x || ''}))}
      />
      <Component>
        {product.status === FETCH_STATUSES.LOADING ? (
          <Spinner/>
        ) : product.status === FETCH_STATUSES.SUCCESS ? (
          gallery &&
          !!gallery.length && (
            <>
              {gallery[currentIndex]?.text && (
                <Description>{gallery[currentIndex].text}</Description>
              )}
              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                onSlideChange={(e) => {
                  setCurrentIndex(e.realIndex);
                  dispatch(activeIdAdded(e.realIndex));
                }}
                onAfterInit={(e) => {
                  dispatch(activeIdAdded(e.realIndex));
                }}
              >
                {gallery.map((item, index) => (
                  <SwiperSlide key={index} onClick={() => {
                    setOpen(true);
                    setIndex(index);
                  }}>
                    <StyledPicture
                      {...convertThumbnailToPictureProps(item.image?.preview)}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </>
          )
        ) : null}
      </Component>
    </>
  );
}

export default Gallery;

const Component = styled.div`
  position: relative;
  min-height: 200px;

  .swiper-container {
    padding-bottom: 10px;
    height: 100%;
    inset: 0;
  }

  .swiper-pagination {
    bottom: 0;
  }
`;

const StyledPicture = styled(Picture)`
  padding: 15px 10px;
  height: 200px;
  width: 100%;

  picture,
  img {
    height: 100%;
    object-fit: contain;
    object-position: left;
  }
`;

const Description = styled.div`
  margin-top: 10px;
  font-size: 14px;
  line-height: 18px;
  width: 100%;
  background: #e9e9e9;
  text-align: center;
  padding: 5px 10px;
  min-height: 28px;
`;
